export default {"src":"/_next/static/media/NOK.a3908e80.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};